/**
 * Loading overlay component for app initialization
 */

export function createLoadingOverlay(): HTMLElement {
  const overlay = document.createElement('div');
  overlay.id = 'loading-overlay';
  overlay.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.95);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    font-family: Arial, sans-serif;
  `;
  
  const spinner = document.createElement('div');
  spinner.style.cssText = `
    border: 4px solid #f3f3f3;
    border-top: 4px solid #007bff;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    animation: spin 1s linear infinite;
    margin-bottom: 20px;
  `;
  
  const message = document.createElement('div');
  message.id = 'loading-message';
  message.style.cssText = `
    font-size: 16px;
    color: #333;
    text-align: center;
  `;
  message.textContent = 'Initializing application...';
  
  const errorContainer = document.createElement('div');
  errorContainer.id = 'loading-error';
  errorContainer.style.cssText = `
    display: none;
    margin-top: 20px;
    padding: 15px;
    background: #fff3cd;
    border: 1px solid #ffc107;
    border-radius: 5px;
    max-width: 400px;
  `;
  
  const errorMessage = document.createElement('div');
  errorMessage.id = 'loading-error-message';
  errorMessage.style.cssText = `
    color: #856404;
    margin-bottom: 10px;
  `;
  
  const retryButton = document.createElement('button');
  retryButton.id = 'loading-retry-btn';
  retryButton.textContent = 'Retry';
  retryButton.style.cssText = `
    background: #007bff;
    color: white;
    border: none;
    padding: 8px 20px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
  `;
  retryButton.onmouseover = () => {
    retryButton.style.background = '#0056b3';
  };
  retryButton.onmouseout = () => {
    retryButton.style.background = '#007bff';
  };
  
  errorContainer.appendChild(errorMessage);
  errorContainer.appendChild(retryButton);
  
  overlay.appendChild(spinner);
  overlay.appendChild(message);
  overlay.appendChild(errorContainer);
  
  // Add CSS animation
  const style = document.createElement('style');
  style.textContent = `
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `;
  document.head.appendChild(style);
  
  return overlay;
}

export function showLoadingOverlay(message: string = 'Initializing application...') {
  let overlay = document.getElementById('loading-overlay');
  if (!overlay) {
    overlay = createLoadingOverlay();
    document.body.appendChild(overlay);
  }
  
  const messageEl = document.getElementById('loading-message');
  if (messageEl) {
    messageEl.textContent = message;
  }
  
  const errorContainer = document.getElementById('loading-error');
  if (errorContainer) {
    errorContainer.style.display = 'none';
  }
  
  overlay.style.display = 'flex';
}

export function updateLoadingMessage(message: string) {
  const messageEl = document.getElementById('loading-message');
  if (messageEl) {
    messageEl.textContent = message;
  }
}

export function hideLoadingOverlay() {
  const overlay = document.getElementById('loading-overlay');
  if (overlay) {
    overlay.style.display = 'none';
  }
}

export function showLoadingError(errorMessage: string, onRetry: () => void) {
  const errorContainer = document.getElementById('loading-error');
  const errorMessageEl = document.getElementById('loading-error-message');
  const retryButton = document.getElementById('loading-retry-btn');
  
  if (errorContainer && errorMessageEl && retryButton) {
    errorMessageEl.textContent = errorMessage;
    errorContainer.style.display = 'block';
    
    // Remove old event listeners and add new one
    const newRetryButton = retryButton.cloneNode(true) as HTMLButtonElement;
    retryButton.parentNode?.replaceChild(newRetryButton, retryButton);
    newRetryButton.addEventListener('click', onRetry);
  }
  
  // Hide spinner when showing error
  const spinner = document.querySelector('#loading-overlay > div:first-child') as HTMLElement;
  if (spinner) {
    spinner.style.display = 'none';
  }
}

export function removeLoadingOverlay() {
  const overlay = document.getElementById('loading-overlay');
  if (overlay) {
    overlay.remove();
  }
}
